<template>
  <div id="notification-bubble">
    <div v-for="(notification, key) in notifications" :ref="'bubble' + notification.id" :key="notification.id" class="bubble bounceInRight" v-bind:class="{ fadeOutRight: notification.isClose, hidden: notification.isHide }" v-on:animationend="removeThis(key)">
    <div @click="readNotification(notification.notificationUuid, notification.uuid, notification.type, key)">
      <div class="icon">
        <img src="../../static/img/notification-bubble-icon/iwk-icon-w33.png"/>
      </div>
      <div class="line"/>
      <div class="content">
        <div class="title">{{notification.title}}</div>
        <div class="message">{{notification.body}}</div>
      </div>
    </div>
      <div @click="closeBubble(key)" class="close-button">
          <i class="fa fa-times"/>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'notificationbubble',
    data () {
      return {
        notifications: [],
        limit: 6
      }
    },
    props: {
      afterClickNotification: {
        type: Function
      }
    }, /*
    mounted () {
      this.createBubble({
        title: 'Ahmad Fuadi Reply',
        body: 'New Visitor Create',
        type: 'Complaint',
        uuid: '',
        notificationUuid: ''
      })
    }, */
    methods: {
      removeThis (index) {
        if (this.notifications[index].isClose) {
          this.notifications[index].isHide = true
        }
      },
      createBubble (data) {
        let totalData = 0
        this.notifications.filter((notification, index) => {
          if (!notification.isClose) {
            totalData++
          }
        })
        if (totalData >= this.limit) {
          for (let i = Object.keys(this.notifications).length; i >= this.limit; i--) {
            this.closeBubble(i - 1)
          }
        }
        this.notifications.unshift({
          id: Object.keys(this.notifications).length,
          notificationUuid: data.notificationUuid,
          title: data.title,
          body: data.body,
          type: data.type,
          uuid: data.uuid,
          isClose: false,
          isHide: false
        })
      },
      closeBubble (index) {
        this.notifications[index].isClose = true
      },
      readNotification (notificationUuid, uuid, type, key) {
        this.afterClickNotification(notificationUuid, uuid, type)
        this.closeBubble(key)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/NotificationBubble.vue